var ajaxModalCall = (url, data, myCallback, returnHTML) => {
    $.ajax({
        url: url,
        cache: false,
        type: "POST",
        data: data,
        success: function(html) {
            returnHTML(html, myCallback);
            return false;
        }
    });
}

const ajaxModalCall2 = (url, myCallback, returnHTML) => {
    $.ajax({
        url: url,
        success: function(html) {
            returnHTML(html, myCallback);
            return false;
        }
    });
}

export {
	ajaxModalCall,
	ajaxModalCall2
}
